import { GasPrices } from '@darkforest_eth/types';
import React from 'react';

export function DisplayGasPrices({ gasPrices }: { gasPrices?: GasPrices | null }) {
  return (
    <div>
      {!gasPrices ? (
        'unknown'
      ) : (
        <>
          slo: {gasPrices.slow + ' '}
          avg: {gasPrices.average + ' '}
          fst: {gasPrices.fast + ' '}
        </>
      )}
    </div>
  );
}
